import { motion } from "framer-motion";

// Hairline-weight, top-right "Skip intro" affordance. Fades out gracefully
// once the visitor either clicks it OR the deconstruction completes naturally.
const FADE_INIT = { opacity: 0 };
const FADE_ANIM = { opacity: 0.6 };
const FADE_EXIT = { opacity: 0 };
const FADE_TRANS = { duration: 0.5, ease: [0.22, 1, 0.36, 1] };
const HOVER_FULL = { opacity: 1 };
const FOCUS_FULL = { opacity: 1 };

const BUTTON_STYLE = {
  background: "transparent",
  color: "var(--noor-vellum)",
  border: "1px solid rgba(232,226,214,0.18)",
  letterSpacing: "0.32em",
  textTransform: "uppercase",
  padding: "0.55rem 0.95rem",
  borderRadius: "1px",
};

export default function SkipIntroButton({ onClick }) {
  return (
    <motion.button
      type="button"
      data-testid="skip-intro-button"
      aria-label="Skip intro animation"
      onClick={onClick}
      initial={FADE_INIT}
      animate={FADE_ANIM}
      exit={FADE_EXIT}
      transition={FADE_TRANS}
      whileHover={HOVER_FULL}
      whileFocus={FOCUS_FULL}
      className="fixed top-3 right-4 z-[60] font-mono text-[10px] cursor-pointer"
      style={BUTTON_STYLE}
    >
      Skip intro
    </motion.button>
  );
}
